export default "__VITE_ASSET__B_g9bKgk__"